import { Component } from '@angular/core';

@Component({
  selector: 'wsb-partner-analytics',
  templateUrl: './partner-analytics.component.html',
  styleUrls: ['./partner-analytics.component.scss'],
  standalone: false
})
export class PartnerAnalyticsComponent {
  activeId = 1;

  constructor() {}
}
